module.exports = __webpack_public_path__ + "img/3-8-IMG_3001.f16ede4c.png";